import { PigGender } from "./pig-gender.type";

export class PigGenderTypes {
  static readonly Sow: PigGender = { id: 0, name: 'So' };
  static readonly Castrate: PigGender = { id: 1, name: 'Galt' };
  static readonly MixedControlled: PigGender = { id: 4, name: 'Blandet, men styret' };
  static readonly MixedUnknown: PigGender = { id: 5, name: 'Blandet, køn ukendt' };
  static readonly MalePig: PigGender = { id: 8, name: 'Hangris' };
}
